import styles from './DotLoader.module.css';

export const DotLoader = () => <span className={styles.Loader} />;

export default DotLoader;
